module.exports = __webpack_public_path__ + "static/media/21ECLAC16.d41d25ed.jpg";